import { Settings2FAContext } from "../types/Settings2FAContext";
import { Settings2FAEvent } from "../types/Settings2FAEvent";

export const set2FAEnabledAction = (
  context: Settings2FAContext,
  event: Settings2FAEvent
): Partial<Settings2FAContext> => {
  if (event.type !== "ENABLE_SUCCESS") {
    throw new Error("Invalid event type");
  }
  return {
    is2FAEnabled: true,
    qrCodeUrl: undefined,
  };
};
